import { SYSTEM_ICONS, SystemIcon } from '../registry'

export function isSystemIcon(icon: string): icon is SystemIcon {
	return Object.prototype.hasOwnProperty.call(SYSTEM_ICONS, icon)
}
